import React from 'react';
import Head from 'next/head';
import { phoneNumber } from '@/components/CourseDescriptionPageProfessional/CourseCurriculum/constants';
import BaseLayout from '@/components/common/BaseLayout';
import TAGS from '../../public/headJson.json';
import ContactUs from '../components/ContactUs';
import RouteName from '../utils/route.util';

const structData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  image: 'https://blog.pwskills.com/wp-content/uploads/2023/05/PWSkills-main-4.png',
  url: 'https://pwskills.com/',
  sameAs: ['https://www.linkedin.com/company/pw-skills-official/'],
  logo: 'https://blog.pwskills.com/wp-content/uploads/2023/05/PWSkills-main-4.png',
  name: 'PW Skills',
  description:
    'PW Skills is your one-stop-shop for upscaling. Get maximum value for time and resources you invest, with job-ready courses & high-technology available at the lowest cost.',
  email: 'support@pwskills.com',
  telephone: phoneNumber,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Block B, Industrial Area, Sector 62',
    addressLocality: 'Noida',
    addressCountry: 'IN',
    addressRegion: 'UP',
    postalCode: '201309',
  },
};

const ContactUsPage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.contactUs.title}</title>
        <meta name="title" content={TAGS.contactUs.title} />
        <meta name="description" content={TAGS.contactUs.desc} />
        <link rel="canonical" href={`${RouteName.contactUs}/`} />

        {/* Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={RouteName.contactUs} />
        <meta property="og:title" content={TAGS.contactUs.title} />
        <meta property="og:description" content={TAGS.contactUs.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.contactUs} />
        <meta property="twitter:title" content={TAGS.contactUs.title} />
        <meta property="twitter:description" content={TAGS.contactUs.desc} />
        <script
          key="contactpage-logo-organisation"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structData) }}
        />
      </Head>
      <BaseLayout category={undefined}>
        <ContactUs />
      </BaseLayout>
    </>
  );
};

export default ContactUsPage;
